import { EventEmitter, Injectable } from '@angular/core';

import { SearchKeyType, StatisticsFilters } from '../models/statistics';


@Injectable({
    providedIn: 'root'
})
export class StatisticsService {

    statisticsSelectsChanged: EventEmitter<StatisticsFilters> = new EventEmitter();
    statisticsRefreshChanged: EventEmitter<StatisticsFilters> = new EventEmitter();
    statisticsTablePaginationChanged: EventEmitter<void> = new EventEmitter();
    tableChanged: EventEmitter<void> = new EventEmitter();
    
    isChartGeneratedDocumentsReadyToRefresh: boolean = false;
    isChartAverageWaitTimeReadyToRefresh: boolean = false;
    isCardsReadyToRefresh: boolean = false;

    notifyStatisticsSelectsChange(dge: number, numberHours: number, customNumberHoursFrom: string, customNumberHoursTo: string, lastJobId: number): void {
        this.statisticsSelectsChanged.emit(new StatisticsFilters(dge, numberHours, customNumberHoursFrom, customNumberHoursTo, lastJobId));
    }

    notifyTableChange(): void {
        this.tableChanged.emit();
    }

    notifyStatisticsRefreshChange(dge: number, numberHours: number): void {
        this.statisticsRefreshChanged.emit(new StatisticsFilters(dge, numberHours, '', '', 0));
    }

    notifyStatisticsTablePaginationChange(): void {
        this.statisticsTablePaginationChanged.emit();
    }

    chartReadyToRefresh(keyChart: string): void {
        if (keyChart === SearchKeyType.AverageWaitTime) {
            this.isChartAverageWaitTimeReadyToRefresh = true;
        } else {
            this.isChartGeneratedDocumentsReadyToRefresh = true;
        }
    }

    cardReadyToRefresh(): void {
        this.isCardsReadyToRefresh = true;
    }

    isStatisticsElementsReadyToRefresh(): boolean {
        return this.isChartGeneratedDocumentsReadyToRefresh
            && this.isChartAverageWaitTimeReadyToRefresh
            && this.isCardsReadyToRefresh;
    }

    resetStatisticsElementsReadyToRefresh(): void {
        this.isChartGeneratedDocumentsReadyToRefresh = false;
        this.isChartAverageWaitTimeReadyToRefresh = false;
        this.isCardsReadyToRefresh = false;
    }

}
